import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TapestryButtonModule } from '@predictiveindex/tapestry';
import { IconsModule } from '../Icons';
import { DirectivesModule } from './../Directives/Directives.module';
import { UpgradeAccountComponent } from './upgrade-account.component';

export const UpgradeAccountExports = [UpgradeAccountComponent];

@NgModule({
    declarations: [...UpgradeAccountExports],
    exports: [...UpgradeAccountExports],
    imports: [CommonModule, DirectivesModule, IconsModule, TapestryButtonModule]
})
export class UpgradeAccountModule {}
